/*eslint eqeqeq: ["error", "smart"]*/
import * as React from 'react';
import $ from 'jquery';
import { RCUtils } from './../../RCUtils';
import Excel from '../../actions/ExportToExcel.js';
import { PopupWindow } from '../sharedcomponents/PopupWindow';
import * as RCNGWindow from './../sharedcomponents/ConfirmationWindow';
import DateFormat from 'dateformat';
var Config: any = require('../../Config.json');

interface SendEmailState {
    EmailFilters: EmailFields;
    okMethod: Function;
    cancelMethod: Function;
    confirmationMsg: string;
    dateTime: any;
    confirmOk: boolean;
}

var currentDateTime;
var self;

export class EmailControl extends React.Component<any, SendEmailState> {
    myRequest: any;
    constructor(props: any) {        
        super(props); 
        var filterSet = this.clearEmailFiltersGenset();
        this.state = { EmailFilters: filterSet, okMethod: Function, cancelMethod: Function, confirmationMsg: '', dateTime: currentDateTime, confirmOk: false };
        self = this;
    }

    FromEmailchange(event: React.FormEvent<HTMLInputElement>) {
        var filters = this.state.EmailFilters;
        var Value: string = event.currentTarget.value;
        filters.SelectedFrom = Value;
        this.setState({
            EmailFilters: filters
        });
    }

    Subjectchange(event: React.FormEvent<HTMLInputElement>) {
        var filters = this.state.EmailFilters;
        var Value: string = event.currentTarget.value;
        filters.SelectedSubject = Value;
        this.setState({
            EmailFilters: filters
        });
    }

    ToEmailchange(event: React.FormEvent<HTMLInputElement>) {
        var filters = this.state.EmailFilters;
        var Value: string = event.currentTarget.value;
        filters.SelectedTo = Value;
        this.setState({
            EmailFilters: filters
        });
    }

    Messagechange(event: React.FormEvent<HTMLTextAreaElement>) {
        var filters = this.state.EmailFilters;
        var Value: string = event.currentTarget.value;
        filters.SelectedMessage = Value;
        this.setState({
            EmailFilters: filters
        });
    }

    dateTypeFormatter(eventDate: Date) {
        var timeZoneOffset = JSON.parse(sessionStorage.getItem('UserInfo')).TimeZoneOffSet;
        var eventdttm = new Date();
        if (eventDate != null)
            eventdttm = new Date(eventDate.toString());
        var utc = eventdttm.getTime() + (eventdttm.getTimezoneOffset() * 60000);
        var prefDateTime = new Date(new Date(utc).getTime() + (60000 * (parseInt(timeZoneOffset))));
        return DateFormat(prefDateTime, 'mm/dd/yyyy HH:MM:ss');
    }

    clearEmailFiltersGenset() {
        currentDateTime = this.dateTypeFormatter((new Date()));
        var filters: EmailFields = {
            SelectedTo: "", SelectedFrom: Config.DefaultEmailAddress, SelectedSubject: "", SelectedAttachment: "", SelectedMessage: "", SelectedForm: ""
        };
        this.setState({
            EmailFilters: filters, confirmOk: false, dateTime: currentDateTime
        });
        return filters;
    }

    componentWillReceiveProps(nextprops: any) {
        this.clearEmailFiltersGenset();
        RCNGWindow.ConfirmWindow.close();
    }

    closeConfirmation() {
        this.setState({
            confirmOk: false
        });
        RCNGWindow.ConfirmWindow.close();
    }

    SendEmailToUser() {
        var uri;
        var isLimitNumberOfEmailsReached: boolean = false;
        if (this.state.EmailFilters.SelectedTo !== undefined || this.state.EmailFilters.SelectedTo !== "") { // WI-26789
            var SendTo = this.state.EmailFilters.SelectedTo;
            var SendFrom = this.state.EmailFilters.SelectedForm;
            var SendToArray = SendTo.split(",");
            var validemail = true;
            var myEmailVLD = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9\-\.])+\.([A-Za-z]{2,4})$/;

            if (SendToArray !== null && SendToArray !== undefined && SendToArray.length < Config.SendEmailLimit) {
            if (SendToArray !== null && SendToArray !== undefined && SendToArray.length > 0) {
                for (var i = 0; i < SendToArray.length; i++) {
                    var valid = myEmailVLD.test(SendToArray[i]);
                    if (!valid) {
                        validemail = false;
                    }
                }
                }
            }            
            else {
                isLimitNumberOfEmailsReached = true;
                validemail = false;
            }

            if (validemail) {
                if ((this.state.confirmOk === false) && (this.state.EmailFilters.SelectedSubject === "" || this.state.EmailFilters.SelectedMessage === "")) {
                    this.setState({
                        confirmOk: true
                    });
                    if (this.state.EmailFilters.SelectedSubject === "" && !(this.state.EmailFilters.SelectedMessage === ""))
                        var confirmationMessage = "Are you sure you want to send email without Subject";
                    else if (!(this.state.EmailFilters.SelectedSubject === "") && (this.state.EmailFilters.SelectedMessage === ""))
                        var confirmationMessage = "Are you sure you want to send email without Message?";
                    else if (this.state.EmailFilters.SelectedSubject === "" && (this.state.EmailFilters.SelectedMessage === ""))
                        var confirmationMessage = "Are you sure you want to send email without Subject and Message?";
                    RCNGWindow.ConfirmWindow.showConfirmBox(confirmationMessage, this.SendEmailToUser.bind(this), this.closeConfirmation.bind(this));
                }
                else {
                    this.setState({
                        confirmOk: false
                    });
                    RCNGWindow.ConfirmWindow.close();

                    if (this.props.parentchild === "P") {
                        uri = Excel.SendmailExportParent(this.props.reeferStatusResult, this.props.columnDefinition, this.props.formname);
                    }
                    else {
                        uri = Excel.SendmailExport(this.props.reeferStatusResult, this.props.columnDefinition, this.props.formname);
                    }
                    this.state.EmailFilters.SelectedForm = this.props.formname;
                    this.state.EmailFilters.SelectedAttachment = JSON.stringify(uri);
                    var filterParams = JSON.stringify(this.state.EmailFilters);
                    $('#globalLoader').show();
                    var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/Email/SendEmail', { method: 'POST', body: filterParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } })
                    //fetch(request)
                    //    .then(response => response)
                    RCUtils.fetchRetry(request)
                        .then(RCUtils.handleResponse)
                        .then(response => response.json() as Promise<string>)
                        .then(data => {
                            $('#sendEmail .close').click();
                            $('#globalLoader').hide();
                            if (this.props.formname === undefined || this.props.formname === null || this.props.formname === undefined || this.props.formname === 'undefined') {
                                $("#contextMenuModel .close").click();
                                $("#EmailGroupModal .btn-close").click();
                            }
                            else if ((this.props.formname.trim() === "ReeferFileRepositoryGrid")) {
                                $("#ReeferFRContextMenu .btn-close").click();
                            }
                            else if ((this.props.formname.trim() === "GeofenceFileRepositoryGrid")) {
                                $("#GeofenceFRContextMenu .btn-close").click();
                            }
                            else if ((this.props.formname.trim() === "RCDFileRepositoryGrid")) {
                                $("#RCDFRContextMenu .btn-close").click();
                            }
                            else if ((this.props.formname.trim() !== "ReeferCommands") && (this.props.formname.trim() !== "TripStatus") && (this.props.formname.trim() !== "LastPreTrip") && (this.props.formname.trim() !== "PreTrip") && (this.props.formname.trim() !== "SchedulePreTrip") && (this.props.formname.trim() !== "StopPTI")) {
                                $("#contextMenuModel .close").click();
                                $("#EmailGroupModal .btn-close").click();
                            }

                            $('#' + this.props.formname + ' .close').click();
                            $('#PopupEmailTo').hide();
                            $('#dashBoardEmailPopUp').hide();
                            $('#' + this.props.formname).hide();
                            PopupWindow.showErrorMessage("Information", data);// "Email Sent Successfully.");
                        })
                        .catch(err => {
                            $('#globalLoader').hide();
                            $('#PopupEmailTo').hide();
                            $('#dashBoardEmailPopUp').hide();
                            $('#' + this.props.formname).hide();
                            PopupWindow.showErrorMessage("Error", "Error Occurred. Please try again.")
                        });
                }
            }
            else {
                if (isLimitNumberOfEmailsReached) {
                    PopupWindow.showErrorMessage("Alert", "Please check the recipient email id. The recipients email should not be more than " + Config.SendEmailLimit + ".");
                    isLimitNumberOfEmailsReached = false;
                }
                else
                PopupWindow.showErrorMessage("Error", "Please verify entered email addresse(s).");
            }
        }
        else {
            PopupWindow.showErrorMessage("Error", "Please enter email address.");
        }
    }

    static ClearFiltersGenset() {        
        self.clearEmailFiltersGenset();
    }

    public render() {
        return <div className='sendEmail-footer'>
            <div className='row'>
                <div className="col-md-12" id='alert-msg-email'>
                    <div className="alert alert-warning hstack gap-2">
                        <span className='fa-solid fa-square-exclamation fa-lg'></span>
                        <div className='alert-text'><strong>Note:</strong> Enter multiple email addresses separated by comma(,)</div>
                    </div>
                </div>
            </div>
            <div className='row mt-1'>
                <div className="col-md-3 col-lg-3 col-sm-3 col-xs-3 pe-0 text-md-end">
                    <label className='col-form-label'>To: </label></div>
                <div className="col-md-8 col-lg-8 col-sm-8 col-xs-8">
                    <input type='email' name='SelectedTo' className='form-control' onChange={e => this.ToEmailchange(e)} value={this.state.EmailFilters.SelectedTo} />
                </div>
            </div>
            <div className='row mt-1'>
                <div className="col-md-3 col-lg-3 col-sm-3 col-xs-3 pe-0 text-md-end">
                    <label className='col-form-label'>From: </label></div>
                <div className="col-md-8 col-lg-8 col-sm-8 col-xs-8">
                    <input type='text' name='SelectedFrom' className='form-control' value={this.state.EmailFilters.SelectedFrom} disabled />
                </div>
            </div>
            <div className='row mt-1'>
                <div className="col-md-3 col-lg-3 col-sm-3 col-xs-3 pe-0 text-md-end">
                    <label className='col-form-label'>Subject: </label></div>
                <div className="col-md-8 col-lg-8 col-sm-8 col-xs-8">
                    <input type='text' name='SelectedSubject' className='form-control' onChange={e => this.Subjectchange(e)} value={this.state.EmailFilters.SelectedSubject} />
                </div>
            </div>
            <div className='row mt-1'>
                <div className="col-md-3 col-lg-3 col-sm-3 col-xs-3 pe-0 text-md-end">
                    <span className='col-form-label'>Attachment: </span></div>
                <div className="col-md-8 col-lg-8 col-sm-8 col-xs-8">
                    <span className='col-form-label'>{this.props.formname}  {this.state.dateTime}</span>
                </div>
            </div>
            <div className='row mt-1'>
                <div className="col-md-3 col-lg-3 col-sm-3 col-xs-3 pe-0 text-md-end">
                    <label className='col-form-label'>Message: </label>
                </div>
                <div className="col-md-8 col-lg-8 col-sm-8 col-xs-8">
                    <textarea id='txtMessage' className='form-control texarea-100' onChange={e => this.Messagechange(e)} value={this.state.EmailFilters.SelectedMessage} ></textarea>
                </div>
            </div>
            <div className='modal-footer mt-2'>
                <button type='button' className='btn btn-primary' onClick={this.SendEmailToUser.bind(this)}>Send</button>
            </div>
        </div>
    }
}

class EmailFields {
    SelectedTo: string;
    SelectedFrom: string;
    SelectedSubject: string;
    SelectedAttachment: string;
    SelectedMessage: string;
    SelectedForm: string;
}